import { SidebarMenuItem } from "../../types/types";
import { MdArrowForwardIos } from 'react-icons/md';
import { Link } from "react-router-dom";

interface props {
  key: string;
  item: SidebarMenuItem;
}

export const SidebarMenuItemComponent: React.FC<props> = ({ item }) => (
  <div className="gm-sidebar-menu-item-component">
    <Link to={item.url} >
      <div className='gm-item-content'>
        <item.icon size={32} />
        <span className="gm-item-label">{item.label}</span>
      </div>
      <MdArrowForwardIos />
    </Link>
  </div>
);
